// User Model
import { Model } from '@vuex-orm/core';

export default class LessonV4 extends Model {
    // This is the name used as module name of the Vuex Store.
    static entity = 'lessonsv4';

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            slug: this.attr(''),
            content: this.attr(''),
            description: this.attr(''),
            image: this.attr(''),
            publication_date: this.attr(null),
            index: this.attr(0),
            trophy_id: this.attr(null),
            content_kind: this.attr('text'),
            module_id: this.attr(null),
            module_name: this.attr(''),
            module_slug: this.attr(''),
            course_name: this.attr(''),
            course_image: this.attr(''),
            course_slug: this.attr(''),
            attachments: this.attr([]),
            footer: this.attr(null),
            quiz: this.attr(null),
            highlighted_content: this.attr(''),
            scripts: this.attr([]),
            seen: this.attr(false),
            quizzes: this.attr([]),
            videos: this.attr([]),
            modules: this.attr([]),
            author: this.attr(false),
            product_settings: this.attr([]),
            availability: this.attr({}),
            unlocks_at: this.attr(''),
            module: this.attr(null),
            media: this.attr([]),
        };
    }

    static apiConfig = {
        actions: {
            fetchById(route_params) {
                const params = new URLSearchParams();

                return new Promise((resolve, reject) => {
                    this.get(`/api/v4/e-learning/courses/${route_params.course_slug}/modules/${route_params.module_slug}/lessons/${route_params.lesson_slug}`, {
                        params,
                        dataTransformer: (response) => response.data.data,
                    })
                        .then((response) => {
                            resolve(response.response.data.data);
                        })
                        .catch((response) => {
                            reject(response);
                        });
                });
            },

            complete(route_params, complete) {
                return new Promise((resolve) => {
                    this.post(
                        `/api/v4/e-learning/courses/${route_params.course_slug}/modules/${route_params.module_slug}/lessons/${route_params.lesson_slug}`,
                        {
                            action: complete ? "complete" : "incomplete",
                        },
                        {
                            save: false,
                        }
                    ).then(() => {
                        resolve();
                    });
                });
            },
        },
    };
}

window.LessonV4 = LessonV4;
